import React, { ReactNode } from 'react';
import { __ } from 'first-intl';
import { WsBonusShopHistoryTransaction } from '../../../ws/result/WsBonusShopHistory';
import { DateUtil } from '@hugendubel/utils';
import { PlainMessageId } from '../../../messages';
import { Money } from '@hugendubel/ws_client';

const _BonusPointTransaction = {
    getTransactionTypeMsgId: (transaction: WsBonusShopHistoryTransaction): PlainMessageId => {
        switch (transaction.type.toUpperCase()) {
            case 'EARN':
                return 'page.PointHistory.transactionType.earn';
            case 'BURN':
                return 'page.PointHistory.transactionType.burn';
            default:
                return 'page.PointHistory.transactionType.unknown';
        }
    },
};

const renderExpired = (date: Date): ReactNode | undefined =>
    +date < Date.now() ? __('page.PointHistory.transaction.expired') : undefined;

const renderDate = (date: Date, addition?: ReactNode) => (
    <time dateTime={date.toISOString()}>
        {DateUtil.toGermanString(date)}
        {addition && ' '}
        {addition}
    </time>
);
const renderRevenueOrValidUntil = ({ revenue, validUntil }: WsBonusShopHistoryTransaction) =>
    process.env.IS_HUDU
        ? revenue && Money.getFormatted(revenue)
        : validUntil && renderDate(validUntil, renderExpired(validUntil));

export type BonusPointTransactionProps = { transaction: WsBonusShopHistoryTransaction };

export const BonusPointTransaction: React.FC<BonusPointTransactionProps> = ({ transaction }) => {
    const pointsClassName = transaction.points.value < 0 ? 'points-burn' : 'points-earn';
    return (
        <tr>
            <td className={'pointsDirection ' + pointsClassName} />
            <td className="transaction-time">{renderDate(transaction.date)}</td>
            <td className="transaction-type">{__(_BonusPointTransaction.getTransactionTypeMsgId(transaction))}</td>
            <td className="transaction-revenue">{renderRevenueOrValidUntil(transaction)}</td>
            <td className="bon-id">{transaction.bonId}</td>
            <td className={'points ' + pointsClassName}>{transaction.points.getFormatted()}</td>
        </tr>
    );
};
